import Bioheader from './Bioheader';
import Biofooter from './Biofooter';
import Biodatamain from './Biodatamain';
import { useEffect } from "react";
import "./Biodata.scss";


function Biodata() {
  useEffect(() => {
    document.body.classList.add("biodata_body");

    return () => {
      document.body.classList.remove("biodata_body"); // cleanup
    };
  }, []);
  return (
    <div className='container '>
      <Bioheader />
      <Biodatamain />
      <Biofooter />
    </div>
  )
}

export default Biodata
